// cspell:ignore UNNORMALIZED

import { MIN_YEAR } from 'components/YearPicker'

export const calculateDateFieldValue = (dateValue: Date | null): number | null => {
  if (!dateValue) {
    return null
  }

  if (dateValue.getFullYear() >= MIN_YEAR) {
    return new Date(Date.UTC(dateValue.getFullYear(), 1)).getUTCFullYear()
  } else {
    return 0
  }
}
